import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
// import * as qs from 'qs';
import { updateAuthToken, updateSAdmin } from "../actions/app";
import { API_URL, USER_SERVICE_URL } from "../config/urls";
var Login = /** @class */ (function (_super) {
    tslib_1.__extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            email: '',
            password: '',
            files: null
        };
        return _this;
    }
    Login.prototype.Login = function (e) {
        var _this = this;
        e.preventDefault();
        mApp.block('.m-login__signin');
        if (this.state.password === '') {
            toastr.error("Необходимо заполнить поля");
            mApp.unblock('.m-login__signin');
            return;
        }
        var formData = new FormData();
        if (this.state.files && this.state.files[0]) {
            formData.append('key_file', this.state.files[0]);
            formData.append('check_key', "true");
        }
        formData.append('login', this.state.email);
        formData.append('password', this.state.password);
        axios.post(USER_SERVICE_URL + "/api/auth?response_type=token&client_id=9&state=k89f98DFc3612&scope=everything&redirect_uri=https://dv.test.we-change.ru/", formData)
            .then(function (resp) {
            axios.get(API_URL + "/user/check", {
                headers: { 'Authorization': 'Bearer ' + resp.data.text }
            })
                .then(function (res) {
                if (res.data && res.data.code && res.data.code === 200 && res.data.data.is_admin) {
                    mApp.unblock('.m-login__signin');
                    localStorage.setItem('authToken', resp.data.text);
                    _this.props.dispatch(updateAuthToken(resp.data.text));
                    if (res.data.data && res.data.data.roles && res.data.data.roles.indexOf("sadmin") > -1) {
                        _this.props.dispatch(updateSAdmin(true));
                    }
                    else {
                        _this.props.dispatch(updateSAdmin(false));
                    }
                }
                else {
                    mApp.unblock('.m-login__signin');
                    alert("Пользователь не существует или не имеет прав администратора");
                }
            })
                .catch(function (err) {
                console.log(err.message);
                mApp.unblock('.m-login__signin');
            });
        }).catch(function (error) {
            console.log(error.response);
            mApp.unblock('.m-login__signin');
        });
    };
    Login.prototype.render = function () {
        var _this = this;
        var url = new URL(window.location.href);
        var isAdmin = false;
        if (url.searchParams.get("sadmin") === 'true') {
            isAdmin = true;
        }
        return (React.createElement("div", { className: "m-grid m-grid--hor m-grid--root m-page" },
            React.createElement("div", { className: "m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2", id: "m_login", style: { backgroundImage: "url(/assets/images/bg-3.jpg)" } },
                React.createElement("div", { className: "m-grid__item m-grid__item--fluid\tm-login__wrapper" },
                    React.createElement("div", { className: "m-login__container" },
                        React.createElement("div", { className: "m-login__signin" },
                            React.createElement("div", { className: "m-login__head" },
                                React.createElement("h3", { className: "m-login__title" }, "\u0412\u0445\u043E\u0434 \u0432 \u0430\u0434\u043C\u0438\u043D\u043A\u0443")),
                            React.createElement("form", { className: "m-login__form m-form", action: "" },
                                isAdmin && (React.createElement("div", { className: "form-group m-form__group" },
                                    React.createElement("input", { onChange: function (e) {
                                            _this.setState({
                                                email: e.target.value,
                                            });
                                        }, className: "form-control m-input", type: "text", placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D...", name: "email", autoComplete: "off" }))),
                                !isAdmin && (React.createElement("div", { className: "row m-login__form-sub" },
                                    React.createElement("div", { className: "col m--align-left m-login__form-left" },
                                        React.createElement("div", { className: "form-group m-form__group" },
                                            React.createElement("label", { htmlFor: "exampleInputEmail1" }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043B\u044E\u0447 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430"),
                                            React.createElement("div", null),
                                            React.createElement("div", { className: "custom-file" },
                                                React.createElement("input", { onChange: function (e) {
                                                        console.log("FILE", e.target.files);
                                                        _this.setState({
                                                            files: e.target.files
                                                        });
                                                    }, type: "file", className: "custom-file-input", id: "customFile" }),
                                                React.createElement("label", { className: "custom-file-label", htmlFor: "customFile" }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0444\u0430\u0439\u043B")))))),
                                React.createElement("div", { className: "form-group m-form__group" },
                                    React.createElement("input", { onChange: function (e) {
                                            _this.setState({
                                                password: e.target.value,
                                            });
                                        }, className: "form-control m-input m-login__form-input--last", type: "password", placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C...", name: "password" })),
                                React.createElement("div", { className: "row m-login__form-sub" },
                                    React.createElement("div", { className: "col m--align-left m-login__form-left" },
                                        React.createElement("label", { className: "m-checkbox  m-checkbox--focus" },
                                            React.createElement("input", { type: "checkbox", name: "remember" }),
                                            " \u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043C\u0435\u043D\u044F",
                                            React.createElement("span", null)))),
                                React.createElement("div", { className: "m-login__form-action" },
                                    React.createElement("button", { id: "m_login_signin_submit", className: "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primary", onClick: this.Login.bind(this) }, "\u0412\u043E\u0439\u0442\u0438")))))))));
    };
    return Login;
}(React.Component));
export default connect(function (state) { return ({
    authToken: state.app.get("auth_token"),
}); })(Login);



//////////////////
// WEBPACK FOOTER
// ./src/views/Login.tsx
// module id = 210
// module chunks = 0